<template lang="pug">
  .agreements-and-rules(:class="ca_ncsa_present ? 'preview-height' : ''")
    ncsa_modal_partial(:show="ncsa_modal.show" :registration_id="registration_id" :organization_id="organization_id" :program_id="program_id" @close="ncsa_modal.show=false; selected=null" @close_success="ncsa_modal.show=false" event_id="registration" ca_ncsa_present="ca_ncsa_present" :program_name="program_name" :org_name="org_name" :ncsa_modal_data="ncsa_modal_data" :interest_level="interest_level")
    .row
     .columns(:class="ca_ncsa_present ? 'large-12 ncsa-content' : 'large-24'")
        article.content-block
          header
            .title
              |{{t('app.ncsa.modal_title')}}
          section.content
            validation-provider(v-slot="{ errors }" rules="required")
              .row.ncsa_promo
                .ncsa_content(:style="wallpaperStyleMain")
                  .columns.large-24(v-if="state.current_reg.program.program_type !='athletic'")
                    img(:class="ca_ncsa_present ? 'ncsa-logo-margin' : ''" class="ncsa_logo" alt='NCSA Logo' :src="ncsalogo")
                    p.non-athletic-statement( v-html="t('app.ncsa.promo2')")
                  .columns
                    .ncsa_promo_text
                      p(v-if="state.current_reg.program.program_type=='athletic'" v-html="t('app.ncsa.promo4')")
                      
                  .columns(v-if="state.current_reg.program.program_type=='athletic'")
                    .ncsa_promo_text.athletic
                      span(v-html="t('app.ncsa.promo5')")
                      span(v-html="t('app.ncsa.promo6')")
                      span(v-html="t('app.ncsa.promo7')")
                  br
                  .columns
                    p.radio-promo(v-if="['athletic', 'coaches', 'combined'].includes(state.current_reg.program.program_type)")
                      span.required *
                      |
                      span(v-html="t('app.ncsa.interest_label')")

                    .field
                      select(v-model="interest_level" @change="handleInterestChange" required :class="{ error: errors.length }")
                        option(disabled value="") {{ t('app.ncsa.select_prompt') }}
                        option(value="1") {{ t('app.ncsa.interest_1') }}
                        option(value="2") {{ t('app.ncsa.interest_2') }}
                        option(value="3") {{ t('app.ncsa.interest_3') }}
                        option(value="no") {{ t('app.ncsa.interest_4') }}
                  br
                  .columns(v-if="state.current_reg.program.program_type=='athletic'")
                    .ncsa_promo_text.testimonial(style="color: #0072CE;")
                        span(v-html="t('app.ncsa.testimonial')")
                        br
                        span.testimonial-name(v-html="t('app.ncsa.testimonial_name')")
                .ncsa_wallpaper(v-if="state.current_reg.program.program_type=='athletic'" :style="wallpaperStyle")
                  img.ncsa_wall(alt='NCSA wallpaper' :src="ncsawallpaper")
</template>

<script>
import ncsalogo from 'images/NCSA_logo.png'
import ncsawallpaper from 'images/NCSA_wallpaper.png'
import ncsa_modal_partial from '../../shared/ncsa_modal'
export default {
  name: "ncsa_block",
  components: {ncsa_modal_partial},
  props: ['program_id', 'organization_id', 'registration_id', 'ca_ncsa_present', 'program_name', 'org_name'],
  data(){
    return {
      ncsalogo,
      ncsawallpaper,
      selected: null,
      interest_level: '',
      ncsa_modal: {
        show: false,
      },
      ncsa_modal_data: null
    }
  },
  computed: {
    wallpaperStyle() {
      return this.state.current_reg.program.program_type === 'athletic' ? { width: '42%' } : { width: '0' };
    },
    wallpaperStyleMain() {
      return this.state.current_reg.program.program_type === 'athletic' ? { width: '58%' } : { width: '100' };
    }
  },
  methods: {
    handleInterestChange() {
      if (["1", "2", "3"].includes(this.interest_level)) {
        this.ncsa_modal_data = this.state.current_reg.registration_form_blocks;
        this.ncsa_modal.show = true;
      }
      else {
        this.ncsa_modal.show = false;
      }
    }
  }
}
</script>
<style scoped lang="scss">
.non-athletic-statement{
  color: var(--Brand-Primary-Text, #333);
  font-family: "Proxima Nova", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; 
  letter-spacing: 0.07px;
}
.ncsa_wallpaper{
  display: flex;
}
.ncsa_wall{
  height: 20rem;
  flex-shrink: 0;
  margin-top: -1rem;
  @media (max-width: 768px) {
    width:15rem;
    height: 15rem;
  }
}
.ncsa_allow{
  color: var(--Brand-Primary-Text, #333);
  font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.ncsa_logo{
   width: 150px;
   display: inline-block;
   float:left;
}
.athletic{
  margin-bottom: 1rem;
}
.ncsa_promo_text{
  @media (max-width: 768px) {
    width:100%;
  }
  @media only screen and (min-width: 820px) and (max-width: 1180px) { 
    width: 100%;
  }
  display:inline-block;
  width:100%;
  padding-top:5px;
  font-size: 14px !important;
  color: var(--Brand-Primary-Text, #333333);
  font-family: "sans-serif";
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: 0.07px;
}
.radio-promo{
  margin-bottom: 5px;
  color: var(--Brand-Primary-Text, #333);
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 157.143% */
  letter-spacing: 0.07px;
}
.ncsa_promo{
  color: #05101a;
  .label-text{
    font-weight: 100;
  }
}
.parallel-div-ncsa{
  display: inline-block; 
  vertical-align: top;
  width: 40%;
}
.label-text.ncsa_allow.athletic{
  font-size: 14px !important;
  color: var(--Brand-Primary-Text, #333333);
  font-family: "sans-serif";
  font-style: normal;
  font-weight: 400;
}
.testimonial{
  font-size: 1rem !important;
  margin-top: 1.5rem;
}
.testimonial-name{
  float: right;
  margin-top: 0.5rem;
}
span.required {
  font-size: 13px;
}
</style>
